Vendd.Scripts.load(function () {

    var $form = $('.x-resetpassword-form');

    if ($form.length < 1)
        return;

    var form = $form.get(0);
    var formData = {
        code: $form.data('code'),
        notificationType: $form.data('notification-type'),
        password: "",
        passwordConfirmation: ""
    };

    form.loading = function (loading) {
        if (loading) {
            $form.addClass('x-loading');
        } else {
            $form.removeClass('x-loading');
        }
    };

    form.onSuccess = function (envelope) {
        form.loading(false);

        var data = envelope.message.data;
        if (data.success && data.code === "ResetPassword_OperationSuccesful") {
            $('.js-error', $form).hide();
            $('.js-expired', $form).hide();
            $('.js-content', $form).hide();
            $('.js-success', $form).show();

            $('input[name="password"]', $form).val("");
            $('input[name="passwordConfirmation"]', $form).val("");
        } else {
            if (data.code === 'ResetPassword_CodeExpired') {
                $('.js-error', $form).hide();
                $('.js-expired', $form).show();

                $('input[name="password"]', $form).val("");
                $('input[name="passwordConfirmation"]', $form).val("");

            } else {
                $('.js-expired', $form).hide();
                $('.js-error', $form).show();

                $('input[name="password"]', $form).val("");
                $('input[name="passwordConfirmation"]', $form).val("");
            };
        };
    };

    form.onFailure = function (envelope) {
        form.loading(false);

        $('.js-expired', $form).hide();
        $('.js-error', $form).show();

        $('input[name="password"]', $form).val("");
        $('input[name="passwordConfirmation"]', $form).val("");
    };

    form.submit = function () {
        form.loading(true);
        formData.password = $('input[name="password"]', $form).val();
        formData.passwordConfirmation = $('input[name="passwordConfirmation"]', $form).val();
        Vendd.MessageBus.publishAsync(form, new Vendd.User.Messages.ResetPassword(formData.code, formData.password, formData.passwordConfirmation));
    };

    Vendd.MessageBus.subscribe(Vendd.User.Messages.ResetPasswordSuccess, form, form.onSuccess);
    Vendd.MessageBus.subscribe(Vendd.User.Messages.ResetPasswordFailure, form, form.onFailure);

    form.onResendSuccess = function (envelope) {
        form.loading(false);

        var data = envelope.message.data;
        if (data.success) {
            $('.js-error', $form).hide();
            $('.js-expired', $form).hide();
            $('.js-content', $form).hide();
            $('.js-success', $form).show();
        } else {
            $('.js-expired', $form).hide();
            $('.js-error', $form).show();
        };
    };

    form.onResendFailure = function (envelope) {
        form.loading(false);

        $('.js-expired', $form).hide();
        $('.js-error', $form).show();
    };

    form.resend = function () {
        form.loading(true);

        Vendd.MessageBus.publishAsync(form, new Vendd.User.Messages.ResendActivationCode(formData.code, formData.notificationType));
    };

    Vendd.MessageBus.subscribe(Vendd.User.Messages.ResendActivationCodeSuccess, form, form.onResendSuccess);
    Vendd.MessageBus.subscribe(Vendd.User.Messages.ResendActivationCodeFailure, form, form.onResendFailure);

    form.reset = function () {
        $('.js-error', $form).hide();
        $('.js-expired', $form).hide();
        $('.js-success', $form).hide();
        $('.js-content', $form).show();

        $('input[name="password"]', $form).val("");
        $('input[name="passwordConfirmation"]', $form).val("");

        rpf.reset();
    };

    form.updatePasswordBar = function (value) {
        var score = Vendd.Helpers.textStrength(value);

        var $passwordStrength = $('#chkPassLabel, #chkPassText');

        $passwordStrength.removeClass(function (i, css) {
            return (css.match(/(^|\s)level\S+/g) || []).join(' ');
        }).addClass('level' + score);
    };

    $.fn.validationEngine.validations.passwordStrength = Vendd.Validations.passwordStrength;

    //init validation options
    var valOpts = {};

    if ($('.form-row.password', $form).length > 0) {
        valOpts.password = {
            required: 'password-required',
            passwordStrength: {
                validator: 'password-weak',
                config: {
                    limit: $('.form-row.password', $form).data('strength')
                }
            }
        };
    }

    if ($('.form-row.password-confirm', $form).length > 0) {
        valOpts.passwordConfirmation = {
            required: 'password-confirm-required',
            match: {
                validator: 'password-confirm-match',
                matchField: 'password'
            }
        };
    }

    $form.validationEngine(valOpts);
    var rpf = $form.data('validationEngine');

    $form.on('click', '.js-submit-button', function (e) {
        e.preventDefault();
        e.stopPropagation();

        if (rpf.validate())
            form.submit();
    });

    $form.on('click', '.js-resend-button', function (e) {
        e.preventDefault();
        e.stopPropagation();

        form.resend();  
    });

    $form.on('keyup', 'input[name]', function (e) {

        if (e.keyCode === 13) {
            e.preventDefault();
            e.stopPropagation();

            if (rpf.validate())
                form.submit();

            return;
        };

        var $this = $(this);
        var fieldName = $this.attr('name');

        if (fieldName === "password") {
            form.updatePasswordBar($this.val());
        };


        rpf.validate(fieldName);
    });

    $form.on('click', '.js-password-reveal', function (e) {
        e.preventDefault();
        if ($(this).hasClass('shown')) {
            $(this).removeClass('shown').siblings('input').prop('type', 'password');
        } else {
            $(this).addClass('shown').siblings('input').prop('type', 'text');
        }
    });
});
